module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('h2', {
    staticClass: "sec_front"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the preparation of this book I would like to thank all those who have offered advice, support and who have helped me with my research.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I am indebted to M. Yves Martin, Ian James Smith, John Lubomski and Sally Fairweather for their assistance with, and photographing of, archival material during many visits to the Archives Nationales and Service Historique de la Défence Armée du Tére, in Paris. Without their help this book could not have been written.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ronald Pawly is also to be thanked for digital media copies of documents at the Archives Nationales. Without this most generous support the book would have taken far longer to complete.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George Lubomski provided copious material on the history and organisation of the Polish lancers, for which I am very grateful. I am indebted to M. Pierre de Witt, M. Jean-Marc Largeaud, Mr Terry Crowdy, Miss Rachael Cresswell BSc PGCE and Mrs Emily Lancaster BSc MSc for their help in the preparation of the text. Jerome Croyet must be thanked for his permission to reproduce the photographs I have taken of the former Brunon collection. Isabelle Artaud, of the Musée de l’Armée, Paris, is also to be heartily thanked for also providing me with permission to use images of the collections of the Musée de l’Armée.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580bcae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Acknowledgements.vue
// module id = 72
// module chunks = 0